export default "__VITE_ASSET__DZA6KjVi__"